import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SellIcon from "@mui/icons-material/Sell";
import { Dialog, IconButton, Tab, Tabs, Tooltip } from "@mui/material";
import "./ContactDetails.css";
import ContactInformation from "./ContactInformation";
import CreateTicket from "./CreateTicket";
import Interaction from "./Interaction";
import TicketLog from "./TicketLog";
import "../Components/Components.css";
import NewChat from "../Chat/NewChat";
import EditTicket from "../Components/EditTicket";
import Loader from "../Components/Loader";
import { selectContact } from "../Store/Actions/ChatAction";
import { getCustomerDetail } from "../Store/Actions/ContactAction";

const ContactDetails = ({
  changePage,
  contactID,
  setIsContactDetailsModalShown,
  setIsAddEditContactDialogShown,
  setIsLinking,
  setMergeSource,
}) => {
  const [contactDetailData, setContactDetailData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isNewChatOpen, setIsNewChatOpen] = useState(false);

  const [isProcessingSelectContact, setIsProcessingSelectContact] =
    useState(false);

  // Used on WABA chat when sending a call permission request
  const [isSendingCallPermissionRequest, setIsSendingCallPermissionRequest] =
    useState(false);

  const [tab, setTab] = useState(0);
  const [ticketAction, setTicketAction] = useState("");
  const [selectedNumber, setSelectedNumber] = useState("");
  const [selectedPhoneTypeID, setSelectedPhoneTypeID] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const dispatch = useDispatch();

  const { isSelectingContact, selectedChat } = useSelector(
    (state) => state.agent
  );

  const { myInfo } = useSelector((state) => state.auth);
  const { getContactDetails } = useSelector((state) => state.contact);

  useEffect(() => {
    setIsLoading(true);

    getCustomerDetail(contactID)
      .then((response) => {
        if (response.status) {
          console.log("contact data", response.data[0]);
          setContactDetailData(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  }, [getContactDetails]);

  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div role="tabpanel" hidden={value !== index} {...other}>
        {value === index && children}
      </div>
    );
  };

  return (
    <div className="contact-details">
      {isLoading ? (
        <Loader />
      ) : !contactDetailData.length ? (
        <p style={{ margin: "20% 0" }}>Contact detail data not found.</p>
      ) : (
        <>
          <header>
            <AccountCircleIcon className="picture" />
            <div className="data">
              <p className="name">
                {contactDetailData[0][0]?.ContactName
                  ? contactDetailData[0][0].ContactName
                  : "Unknown Contact"}
              </p>
              <p className="ref">
                Ref code: {contactDetailData[0][0]?.ContactRef}
              </p>

              <div className="tags">
                <SellIcon />
                <p>Tag 1, Tag 2</p>
              </div>
            </div>

            {
              // Only show in contact page
              localStorage.getItem("winPage") !== "ticket" && (
                <Tooltip arrow title="Link contact">
                  <IconButton
                    className="link-contact-button"
                    onClick={() => {
                      setIsLinking(true);
                      setIsContactDetailsModalShown(false);

                      setMergeSource({
                        name: contactDetailData[0][0]?.ContactName
                          ? contactDetailData[0][0].ContactName
                          : "Unknown Contact",
                        id: contactID,
                      });
                    }}
                  >
                    <Icon
                      color="#0343C7"
                      icon="mdi:link-variant"
                      width="26"
                      height="26"
                    />
                  </IconButton>
                </Tooltip>
              )
            }
          </header>

          <section className="selected-details">
            <Tabs
              className="tabs"
              TabIndicatorProps={{
                style: {
                  height: "4px",
                  backgroundColor: "#808080",
                },
              }}
              value={tab}
              variant="fullWidth"
              onChange={(event, value) => setTab(value)}
            >
              <Tab
                icon={<Icon icon="mdi:user-alert" height="20" />}
                iconPosition="start"
                label="Information"
              />

              <Tab
                icon={<Icon icon="material-symbols:history" height="20" />}
                iconPosition="start"
                label="Ticket Log"
              />

              {
                // Hide if there is no campaign
                contactDetailData[0][0].CampaignID && (
                  <Tab
                    icon={<Icon icon="mdi:talk" height="20" />}
                    iconPosition="start"
                    label="Interaction"
                  />
                )
              }
            </Tabs>

            <TabPanel value={tab} index={0}>
              <ContactInformation
                data={contactDetailData[1]}
                contactID={contactDetailData[0][0].ContactID}
                campaignID={contactDetailData[0][0].CampaignID}
                name={contactDetailData[0][0].ContactName}
                setIsContactDetailsModalShown={setIsContactDetailsModalShown}
                setIsAddEditContactDialogShown={setIsAddEditContactDialogShown}
                isAddEditButtonShown
                setIsNewChatOpen={setIsNewChatOpen}
                setSelectedNumber={setSelectedNumber}
                setSelectedPhoneTypeID={setSelectedPhoneTypeID}
              />
            </TabPanel>

            <TabPanel value={tab} index={1}>
              <TicketLog
                data={contactDetailData[3]}
                contactID={contactID}
                ticketAction={ticketAction}
                setTicketAction={setTicketAction}
                setSelectedTicket={setSelectedTicket}
                contactDetailData={contactDetailData[1][0]}
              />
            </TabPanel>

            <TabPanel value={tab} index={2}>
              <Interaction data={contactDetailData[2]} />
            </TabPanel>
          </section>

          {isSelectingContact && (
            <button
              className="select-contact-button"
              disabled={isProcessingSelectContact}
              onClick={() => {
                setIsProcessingSelectContact(true);

                selectContact({
                  chatlistid: Number(selectedChat.ChatListID),
                  chatsource: selectedChat.ChatSource,
                  contactid: contactID,
                })
                  .then((response) => {
                    if (response.status) {
                      setIsProcessingSelectContact(false);
                      changePage("chat");
                      toast.success("Contact selected", { autoClose: 3000 });
                    } else {
                      setIsProcessingSelectContact(false);
                      console.log("Error selecting contact", response.error);

                      toast.error("Error selecting contact", {
                        autoClose: 3000,
                      });
                    }
                  })
                  .catch((err) => {
                    setIsProcessingSelectContact(false);
                    console.log("Error selecting contact", err);
                    toast.error("Error selecting contact", { autoClose: 3000 });
                  });
              }}
            >
              Select contact
            </button>
          )}

          <Dialog
            open={ticketAction === "create"}
            className="dialog"
            fullWidth
            maxWidth="lg"
            scroll="paper"
            onClose={() => setTicketAction("")}
          >
            <CreateTicket
              contactID={contactID}
              contactDetailData={contactDetailData[1].find(
                (e) => e.PhoneType === "mobile" || e.PhoneType === "Mobile"
              )}
              contactDetailDataEmail={contactDetailData[1].find(
                (e) => e.PhoneType === "email" || e.PhoneType === "Email"
              )}
              setTicketAction={setTicketAction}
            />
          </Dialog>

          <Dialog
            open={ticketAction === "edit"}
            className="dialog"
            fullWidth
            maxWidth="xl"
            scroll="paper"
            onClose={() => setTicketAction("")}
          >
            <EditTicket
              caseID={selectedTicket}
              setTicketAction={setTicketAction}
            />
          </Dialog>
        </>
      )}

      {isNewChatOpen && (
        <NewChat
          agentID={myInfo.user.AgentID}
          setOpenModal={setIsNewChatOpen}
          isSendingCallPermissionRequest={isSendingCallPermissionRequest}
          setIsSendingCallPermissionRequest={setIsSendingCallPermissionRequest}
          recipientPhoneNo={selectedNumber}
          isFromContactInformation
          contactID={contactID}
          phoneTypeID={selectedPhoneTypeID}
          contactName={contactDetailData[0][0]?.ContactName}
          setIsContactDetailsModalShown={setIsContactDetailsModalShown}
        />
      )}
    </div>
  );
};

export default ContactDetails;
